import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { AButton } from '../atoms/';

export default function MCmsCard({
	title,
	href,
	description,
}) {
	return (
		<Link to={href} href={href}>
			<article className="m-card-cms">
				<div className="text-wrapper">
					<h3>{title}</h3>
					<p>{description}</p>
				</div>
				<AButton value={`ga naar ${title}`} />
			</article>
		</Link>
	);
}
// <Link to={href} href={href}>
MCmsCard.propTypes = {
	title: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	description: PropTypes.string,
};

MCmsCard.defaultProps = {
	description: '',
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.cms-card.js